/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 6/11/15.
 */
'use strict';
angular.module('prism-ui.components.data').service('EnumService',function(EnumResource) {
	var self = this;

	self.EnumMap = null;
    self.enumsPromise = null;

	self.createEnumMap = function (enums) {
		self.EnumMap = {};
		angular.forEach(enums, function(enumItem) {
			var propKey = enumItem.className + '_' + enumItem.propertyName;
			self.EnumMap[propKey] = {};
			angular.forEach(enumItem.picklistItems, function(picklistItem) {
				self.EnumMap[propKey][picklistItem.id] = picklistItem.displayName;
			});
		});
	};

	self.getEnumPicklist = function (propKey) {
        if (!self.EnumMap) {
            console.error('Expected queryForEnums() call before getEnumPicklist()');

        } else {
            var pickListObject = self.EnumMap[propKey];
            if(pickListObject) {
                var returnVal = [];
                angular.forEach(pickListObject, function (value, key) {
                    returnVal.push({displayName: value, id: key});
                });
                return returnVal;
            }
        }
		return propKey;
	};

	self.queryForEnums = function() {
        if (!self.enumsPromise) {
            self.enumsPromise = EnumResource.query().$promise.then(function(enums) {
                self.createEnumMap(enums);
                return self.EnumMap;
            });
        }
        return self.enumsPromise;
	};

	self.getEnumValue = function (propKey, enumKey) {
        if (!self.EnumMap) {
            console.error('Expected queryForEnums() call before getEnumValue()');
        }

		if(self.EnumMap && self.EnumMap[propKey] && self.EnumMap[propKey][enumKey]) {
			return self.EnumMap[propKey][enumKey];
		}
		return enumKey;
	};
});
